
import { Link } from './common/Link';
import { View } from './common/View';

export function DevelopmentTopBar() {
  return (
    <View
      className="text-[var(--color-warningText)] bg-[var(--color-warningBackground)]"
      style={{
        padding: '6px 20px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1px solid var(--color-warningBorder)',
        zIndex: 1,
        flexShrink: 0,
      }}
    >
      <View>This is a demo build of Actual.</View>
      <View>
        <Link
          variant="external"
          linkColor="purple"
          to={`https://github.com/actualbudget/actual/pull/${process.env.REACT_APP_REVIEW_ID}`}
        >
          Open the PR: #{process.env.REACT_APP_REVIEW_ID}
        </Link>
      </View>
    </View>
  );
}
